import { createSlice } from "@reduxjs/toolkit";
import { fetchProviderRooms } from "../../Thunk/getProfileData/providerRooms";
export interface AppState {
    ProviderRoom: any;
    isLoading: boolean;
    error: string | null | undefined;
}

const initialState: AppState = {
    ProviderRoom: null,
    isLoading: false,
    error: null,
};

const ProviderRoomSlice = createSlice({
    name: "providerRooms",
    initialState,
    reducers: {
        // Your other reducers go here
        resetState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProviderRooms.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchProviderRooms.fulfilled, (state, action) => {
                state.isLoading = false;
                state.ProviderRoom = action.payload;
            })
            .addCase(fetchProviderRooms.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export default ProviderRoomSlice;
